import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import PubSub from 'services/PubSub';
import {actionsType} from 'config/constants';
import { useLogged } from 'hooks';
import TagManagerService from 'services/TagManager'
import style from './style.scss';

let actions = [];


const InfoMenssage = ({reviewsLength, productId, itemId}) => {
    const [average, setAverage] = useState(false);
    const isLogged = useLogged(false);

    const comments = reviewsLength >= 1;

    useEffect(() => {
        actions.push(PubSub.register('reviews_average_data', _average));

        return function cleanup() {
            actions.map(token => PubSub.unregister(token));
            actions = [];
        }
    })

    const _modalLoggin = () => {
        PubSub.dispatch(actionsType.MODAL.LOGIN_OPEN)
    }

    const _writeReview = () => {
        PubSub.dispatch(actionsType.DRAWER.WRITER_REVIEWS_OPEN, {productId , itemId})
        TagManagerService.interaction('Escribir comentario (click módulo reviews)', itemId,  'PDP -Reviews');
    }

    const _average = (payload) => {
        setAverage(payload?.value?.data?.average);
    }

    return (
        <>
            {!isLogged && !comments && <div className="info-menssage-wrap">
                <button className="new-link new-link-small info-menssage-button" onClick={_modalLoggin}>Inicia sesión</button>
                <span className="info-menssage-title">para agregar tu calificación</span>
            </div>}

            {!isLogged && comments && <div className="info-menssage-wrap">
                <button className="new-link new-link-small info-menssage-button" onClick={_modalLoggin}>Inicia sesión</button>
                <span className="info-menssage-title">para agregar la primera calificación</span>
            </div>}

            {isLogged && !comments && !average && <div className="info-menssage-wrap">
                <span className="info-menssage-title">Todavía no tiene calificaciones, comparte la tuya.</span>
                <button className="new-link new-link-small info-menssage-button logged" onClick={_writeReview}>Calificar producto</button>
            </div>}
        </>
    )
}

InfoMenssage.propTypes = {
    reviewsLength: PropTypes.number,
    itemId : PropTypes.string
}

export default InfoMenssage;